export const isApple = () => {
  const expression = /(Mac|iPhone|iPod|iPad)/i
  return expression.test(navigator.userAgent)
}
